import { useTheme } from '@mui/material';

import deepTechnicalExpertiseIcon from '../../../public/svg/icons/stellar/deep-technical-expertise.svg';
import endToEndCapabilitiesIcon from '../../../public/svg/icons/stellar/end-to-end-capabilities.svg';
import productionProvenIcon from '../../../public/svg/icons/stellar/production-proven.svg';
import regulatoryAwarenessIcon from '../../../public/svg/icons/stellar/regulatory-awareness.svg';

export const WhyRFData = () => {
  const theme = useTheme();
  return [
    {
      name: 'funded_by_ecosystem',
      icon: deepTechnicalExpertiseIcon,
      title: 'Funded by the Ecosystem',
      boxShadow: theme.mixins.yellowGradientTransparent?.boxShadow || '',
      duration: 4,
      floatingY: 7.4,
      description:
        "We're a two-time Stellar Community Fund grantee, building infrastructure that other projects on the network use. Few development partners have been funded by the SDF to build the network's tooling, and we've been funded for it twice.",
    },
    {
      name: 'deep_soroban_rust_expertise',
      icon: regulatoryAwarenessIcon,
      title: 'Deep Soroban and Rust Expertise',
      boxShadow: theme.mixins.redGradientTransparent?.boxShadow || '',
      duration: 5,
      floatingY: 3,
      description:
        "Soroban is Rust from end to end, and so is our team. We're not learning the stack at your expense. We've already built indexers, data pipelines, and contract-aware systems that handle live Soroban data at scale.",
    },
    {
      name: 'end_to_end_capabilities',
      icon: endToEndCapabilitiesIcon,
      title: 'End-to-End Capabilities',
      boxShadow: theme.mixins.magentaGradientTransparent?.boxShadow || '',
      duration: 2,
      floatingY: 4.5,
      description:
        "From smart contracts to APIs to frontends to AWS infrastructure-as-code, we handle the full stack with one team, so you're not coordinating five separate vendors.",
    },
    {
      name: 'production_proven',
      icon: productionProvenIcon,
      title: 'Production-Proven',
      boxShadow: theme.mixins.yellowGradientTransparent?.boxShadow || '',
      duration: 3,
      floatingY: 4.5,
      description:
        'We build systems that hold up under load: security-audited, load-tested, and monitored from day one. When real money is moving through a system, "mostly working" isn\'t good enough.',
    },
  ];
};
